export default "__VITE_ASSET__CEmacdkl__"